import React from "react";
import "./Carousel.modules.css";
import { useSearchParams } from "react-router-dom";
//carousel
import useEmblaCarousel from "embla-carousel-react";
import { DotButton, useDotButton } from "./CarouselDotButton";
import {
  PrevButton,
  NextButton,
  usePrevNextButtons,
} from "./CarouselArrowButtons";
//components
import CardPlan from "../cards/CardPlan";

const CarouselPlans = ({
  options,
  data,
  user,
  savePlan,
  handleSelect,
  quantity,
}) => {
  const [emblaRef, emblaApi] = useEmblaCarousel(options);
  const [searchParams] = useSearchParams();
  const isFreePlan = searchParams.get("freeplan") === "true";

  const { selectedIndex, scrollSnaps, onDotButtonClick } =
    useDotButton(emblaApi);
  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi);

  return (
    <section className="embla">
      <div className="embla__viewport" ref={emblaRef}>
        <div className="embla__container">
          {data.plans.map((plan, index) => {
            if (plan.free_trial_days) {
              if (isFreePlan) {
                return (
                  <CardPlan
                    key={index}
                    plan={plan}
                    user={user}
                    savePlan={savePlan}
                    quantity={quantity}
                    modules={data.modules}
                    handleSelect={handleSelect}
                  />
                );
              } else {
                return;
              }
            }
            return (
              <CardPlan
                key={index}
                plan={plan}
                user={user}
                savePlan={savePlan}
                quantity={quantity}
                modules={data.modules}
                handleSelect={handleSelect}
              />
            );
          })}
        </div>
      </div>

      <div className="embla__controls">
        <div className="embla__buttons">
          <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
          <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
        </div>

        <div className="embla__dots">
          {scrollSnaps.map((_, index) => (
            <DotButton
              key={index}
              onClick={() => onDotButtonClick(index)}
              className={"embla__dot".concat(
                index === selectedIndex ? " embla__dot--selected" : ""
              )}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default CarouselPlans;
